import Vue from "vue";
import Vuex from "vuex";
import Cookie from "js-cookie";
import settingService from "@/global/service/setting";
import router from "@/router/index";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userAvatar: "",
    userName: "",
    userPhone: "",
    authPermissions: [],
    settingStage: {}
  },
  getters: {},
  mutations: {
    getUserAvatar(state, userAvatar) {
      state.userAvatar = userAvatar;
    },
    getUserName(state, userName) {
      state.userName = userName;
    },
    getUserPhone(state, userPhone) {
      state.userPhone = userPhone;
    },
    getAuthPermissions(state, authPermissions) {
      state.authPermissions = authPermissions;
    },
    getSettingStage(state, stage) {
      state.settingStage = stage;
    }
  },
  actions: {
    login() {
      const DOMAIN = process.env.VUE_APP_DOMAIN;
      const referer = window.location.href;
      const ENV_PREFIX = process.env.NODE_ENV === "uat" ? "uat-" : "";
      const PASSPORT_PREFIX = `https://${ENV_PREFIX}account` + DOMAIN;
      window.location.href = PASSPORT_PREFIX + "/?referer=" + referer;
    },
    logout({ commit }) {
      const DOMAIN = process.env.VUE_APP_DOMAIN;
      Cookie.remove("token", { domain: DOMAIN });
      Cookie.remove("_vip_token", { domain: DOMAIN });
      Cookie.remove("avatar", { domain: DOMAIN });
      Cookie.remove("nickname", { domain: DOMAIN });
      Cookie.remove("uid", { domain: DOMAIN });
      Cookie.remove("uname", { domain: DOMAIN });
      commit("getUserName", "");
      commit("getAuthPermissions", "");
      commit("getUserAvatar", "");
      router.go(0);
      // router.push({ name: "WelcomeHomeSelf" });
    },
    async settingSatage({ commit }) {
      let settingStage = await settingService.stages();
      settingStage.all_finished =
        settingStage.bank_verify_finished &&
        settingStage.base_info_finished &&
        settingStage.realname_verify_finished;
      commit("getSettingStage", settingStage);
    }
  }
});

export default store;
